import React from 'react';
import { bearingToDirection } from '@/utils/map';

interface Props {
  bearing: number;
}

export default function Compass({ bearing }: Props) {
  const direction = bearingToDirection(bearing);

  return (
    <div className="relative flex h-[20px] w-[21px]">
      <svg
        className="absolute left-0 top-0"
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle cx="10.9609" cy="9.99438" r="10" fill="#0A0E14" />
      </svg>
      <div className="left-0 top-0 z-10 flex size-full items-center justify-center text-[9px] font-bold">
        {direction}
      </div>
    </div>
  );
}
